<div class="dialog-header">
    <h6>Approval Request</h6>
    <button mat-icon-button class="close-icon" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="email-dialog">
    <div class="email-section">

        <div class="email-fields">
            <div class="field-container">
                <div class="field-label" style="margin-right: 18px;">
                    <mat-label>To:</mat-label>
                </div>
                <div class="field-input">
                    <mat-chip-grid #chipGrid>
                        <mat-chip-row *ngFor="let email of selectedToEmails" (removed)="removeToEmail(email)">
                            {{ email }}
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                        <input type="text" placeholder="Add email" matInput [formControl]="to"
                            [matAutocomplete]="autoTo" [matChipInputFor]="chipGrid"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            (matChipInputTokenEnd)="addToEmail($event)">
                    </mat-chip-grid>
                    <mat-autocomplete #autoTo="matAutocomplete" (optionSelected)="selectToEmail($event)">
                        <mat-option *ngFor="let option of filteredToOptions | async" [value]="option">
                            {{ option }}
                        </mat-option>
                    </mat-autocomplete>
                    <div class="validation-message" *ngIf="selectedToEmails.length === 0">
                        At least one recipient is required
                    </div>
                </div>
            </div>

            <div class="field-container">
                <div class="field-label" style="margin-right: 15px">
                    <mat-label>CC:</mat-label>
                </div>
                <div class="field-input">
                    <mat-chip-grid #chipGridCc>
                        <mat-chip-row *ngFor="let email of selectedCcEmails" (removed)="removeCcEmail(email)">
                            {{ email }}
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                        <input type="text" placeholder="Add email" matInput [formControl]="cc"
                            [matAutocomplete]="autoCc" [matChipInputFor]="chipGridCc"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            (matChipInputTokenEnd)="addCcEmail($event)">
                    </mat-chip-grid>
                    <mat-autocomplete #autoCc="matAutocomplete" (optionSelected)="selectCcEmail($event)">
                        <mat-option *ngFor="let option of filteredCcOptions | async" [value]="option">
                            {{ option }}
                        </mat-option>
                    </mat-autocomplete>
                    <div class="validation-message" *ngIf="selectedCcEmails.length === 0">
                        At least one CC recipient is required
                    </div>
                </div>
            </div>
        </div>
        <div class="body-field-container">
            <div class="body-field-label">
                <mat-label>Body:</mat-label>
            </div>
            <div class="body-field-input">
                <mat-form-field appearance="outline" class="body-textarea-field">
                    <textarea matInput placeholder="Enter message body" [formControl]="meraki_comment_to_client"
                        rows="3" class="body-textarea"></textarea>
                </mat-form-field>
                <div class="validation-message" *ngIf="body.invalid && (body.dirty || body.touched)">
                    Body is required
                </div>
            </div>
        </div>
        <div class="signature-field-container">
            <div class="signature-field-label">
                <mat-label>Signature:</mat-label>
            </div>
            <div class="signature-field-input">
                <div class="signature-error-field">
                    <mat-form-field appearance="outline" class="signature-input-field">
                        <textarea matInput placeholder="Enter Signature" [formControl]="signature"
                            class="signature-input"></textarea>
                    </mat-form-field>
                    <div class="checkbox-container">
                        <mat-checkbox [formControl]="update_signature">Update Signature</mat-checkbox>
                    </div>
                    <div class="validation-message" *ngIf="signature.invalid && (signature.dirty || signature.touched)">
                        Signature is required
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="comment-section">
        <form [formGroup]="createServiceForm">
            <div class="table-header">
                <div style="transform: scale(0.8);">
                    <mat-checkbox style="width: 30px !important;" (click)="selectAll()"></mat-checkbox>
                </div>
                <div style="width: 20%;">
                    <h6>Service</h6>
                </div>
                <div style="width: 15%;">
                    <h6>System Value</h6>
                </div>
                <div style="width: 15%;">
                    <h6>Agent Value</h6>
                </div>
                <div style="width: 30%;">
                    <h6>Request</h6>
                </div>
            </div>

            <div class="table-content">
                <div class="table-iterate">
                    <div class="table-field-outside" *ngFor="let serviceControl of datasource; let i = index">
                        <div class="table-field">
                            <div>
                                <mat-checkbox [formControl]="serviceControl.get('display_to_client')"
                                    style="width: 30px !important;"></mat-checkbox>
                            </div>
                            <div style="width: 20%;">
                                <h6>{{ serviceControl.get('service')?.value }}</h6>
                            </div>
                            <div style="width: 15%;">
                                <input type="text" [formControl]="serviceControl.get('systemTotal')" readonly>
                            </div>
                            <div style="width: 15%;">
                                <input type="text" [formControl]="serviceControl.get('total')" readonly>
                            </div>
                            <div style="width: 35%; margin-left: -12px;">
                                <mat-checkbox [formControl]="serviceControl.get('client_option')">Client, Owner,
                                    Charter, Other</mat-checkbox>
                            </div>
                        </div>

                        <div class="table-text-area">
                            <textarea [formControl]="serviceControl.get('meraki_remark_client')"
                                placeholder="Enter additional information"></textarea>
                        </div>
                    </div>
                    <div class="button-section">
                        <button mat-flat-button class="cancel-button" (click)="closeDialog()">Cancel</button>
                        <button mat-flat-button class="continue-button"
                            [disabled]="selectedToEmails.length === 0 || selectedCcEmails.length === 0"
                            (click)="onContinue()">Continue</button>
                    </div>
                </div>
            </div>

        </form>
    </div>

</div>